import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Form } from '@carsys/form'
import FormFields from 'app/settings/components/OpeningHours/Form'
import { IWorkHours } from '@cbgms/api'
import { buildValidationSchema, initialValues as defaultValues } from 'app/settings/components/OpeningHours/OpeningHours'
import { BaseStepLayout } from '../BaseStepLayout'
import { StepNavigation } from '../StepNavigation'
import { defaultStepFormProps } from '../types.d'
import { WithRunInBackgroundHelper } from '../use-should-run-in-background'

export const OnboardingOpeningHoursForm: React.FC<defaultStepFormProps<IWorkHours> & { onSubmit: (wh: IWorkHours) => void }> = ({
  onSubmit,
  prevStep,
  isFirstStep,
  isPersisting,
  onSubmitSuccess,
  hideSkip,
  shouldRunInBackground,
  initialData
}) => {
  const { t } = useTranslation()

  const validationSchema = buildValidationSchema(t)
  const formSubmit = async (v: IWorkHours) => {
    onSubmit(v)
    return v
  }

  const initialValues = useMemo(() => ({ ...defaultValues, ...initialData }), [defaultValues, initialData])

  return (
    <BaseStepLayout
      title={t('onboarding.opening_hours.opening_hours_step_header')}
      subTitles={[t('onboarding.opening_hours.opening_hours_step_info')]}
    >
      <Form
        initialValues={initialValues}
        enableReinitialize
        NavigationConfirmation={null}
        validationSchema={validationSchema}
        onSubmit={formSubmit}
        onSubmitSuccess={onSubmitSuccess}
      >
        {({ isSubmitting, handleSubmit }) => (
          <WithRunInBackgroundHelper enabled={shouldRunInBackground} isSubmitting={isSubmitting} onSubmit={handleSubmit}>
            <Box>
              <FormFields />
            </Box>
            <StepNavigation prevStep={prevStep} hideBack={isFirstStep} isLoading={isSubmitting || isPersisting} hideSkip={hideSkip} />
          </WithRunInBackgroundHelper>
        )}
      </Form>
    </BaseStepLayout>
  )
}

export default OnboardingOpeningHoursForm
